import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000/api/v1',
  timeout: 10000,
});

api.interceptors.response.use(r => r.data, err => Promise.reject(err.response?.data || err));

export const getTableMenu = (tableId) => api.get(`/restaurants/table/${tableId}`);
export const createOrder  = (data)    => api.post('/restaurants/orders', data);
export const getOrder     = (orderId) => api.get(`/restaurants/orders/${orderId}`);
export const callWaiter   = (orderId) => api.post(`/restaurants/orders/${orderId}/call-waiter`);

export default api;
